import React, { useEffect, useRef, useState } from 'react';
import { Navigate, useNavigate } from "react-router";
import { User } from '../../Entities/User.ts';
import { LoadingAnimation } from '../../Utils/Progress/progress-component';
import { Modal } from '../../Utils/Modal/modal-component';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import ThemeToggler from '../../Utils/Theme/theme-toggeler-component';
import * as authActions from '../../Redux/Auth/AuthActions';

function ResetPassword() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(authActions.isLoggedIn());
    }, [dispatch]);

    const [email, setEmail] = useState(Cookies.get('email') || '');
    const [resetBtnInfo, setResetBtnInfo] = useState('Reset Password');
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const loading = useSelector((state) => state.loading);
    const resetState = useSelector((state) => state.auth.reset);
    let currentRoute = useSelector((state) => state.auth.currentRoute);
    console.log(resetState);




    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(resetState);
        if (resetState) {
            navigate('/login');
        }
        else {
            resetPasswrd();
        }
    };

    const resetPasswrd = async () => {
        const user = new User(email, '');
        dispatch(authActions.resetPasswrd(user));
        setResetBtnInfo('Login');
    }

    if (isAuthenticated) {
        console.log('authernticated');
        if (currentRoute.toUpperCase() === '/LOGIN' || currentRoute.toUpperCase() === '/RESETPSWD' || currentRoute === '/') {
            currentRoute = '/home'
        }
        return <Navigate to={currentRoute} replace />
    }


    <Modal expand={loading.visible}>
        <LoadingAnimation loadingMessage={loading.message} />
    </Modal>


    return (
        <div className='flex justify-center align-middle'>
            <div className="container-component">
                <div className="login-header">
                    <div className='flex justify-between align-middle'>
                        <div className='flex text-4xl font-bold py-2 text-gray-700 dark:text-gray-50'>Reset Password</div>
                        <div className='flex align-middle justify-center'>
                            <ThemeToggler></ThemeToggler>
                        </div>
                    </div>
                    <div className='text-gray-500 dark:text-gray-200'>Forgot your password? Please enter your details.</div>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="login-container">
                        <div> Email: </div>
                        <input
                            className="input-component"
                            placeholder="user@company.com"
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required={true}
                        />
                    </div>
                    <button className="button-component mb-5" type="submit">{resetBtnInfo}</button>
                </form>
                {resetState && <div className="container flex justify-center align-middle">
                    <div className='text-sm text-gray-500 dark:text-gray-300'>Didn't get an email?</div>
                    <div className='text-sm text-blue-600 dark:text-blue-500 hover:underline px-2 hover:cursor-pointer' onClick={(e) => { e.preventDefault(); resetPasswrd(); }}>send again</div>
                </div>}
                <div className="container flex ustify-center items-center py-5 w-full">
                    <div className="w-full inline-flex justify-center text-sm items-center py-2 font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                        <svg className=" mr-2 -ml-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" strokeWidth="1.5" stroke="currentColor" ><path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" /></svg>
                        <button onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/') }} >Go Back </button>
                    </div>
                </div>
                <div className="container flex justify-center align-middle">
                    <div className='text-sm text-gray-500 dark:text-gray-300'>Don't have an account?</div>
                    <div className='text-sm text-blue-600 dark:text-blue-500 hover:underline px-2 hover:cursor-pointer' onClick={(e) => { e.preventDefault(); console.log('cliked'); navigate('/signup') }}> Sign up
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ResetPassword;